<template>
  <div class="author d-flex flex-sm-row flex-md-column">
    <div class="author-items author-avatar-image">
      <img class="avatar" :src="user.avatar_uri" width="52" height="52" :title="user.public_name" />
    </div>
    <div class="author-items author-name align-self-center align-self-md-stretch">
      <span v-dompurify-html="user.public_name"></span>
      <br />
    </div>
    <div class="author-items author-date align-self-center align-self-md-stretch">
      <small>Verfasst: {{ formattedDate(UTCtoLocalTime(createdDate)) }}</small>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

// stores
import { userStore } from '@/store/user-store';
import { domainStore } from '@/store/domain-store';

// composables
import useConverter from '@/composables/general/useConverter';

export default {
  name: 'forum-author',
  props: {
    user: {
      type: Object,
      required: true,
    },
    createdDate: {
      type: String,
      required: true,
    },
  },

  setup() {
    const { formattedDate, UTCtoLocalTime } = useConverter();

    //
    //-----------------COMPUTED------------------
    //
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });
    const loggedInUser = computed(() => {
      return userStore.getState().user;
    });
    const domainid = computed(() => {
      return domainStore.getState().domainid;
    });

    //
    //-----------------METHODS------------------
    //

    return {
      // REFS

      // COMPUTED
      domainid,
      isLoggedIn,
      loggedInUser,

      // METHODS
      formattedDate,
      UTCtoLocalTime,
    };
  },

  components: {},
};
</script>

<style scoped lang="scss">
@media (min-width: 768px) {
  .author {
    border-right: solid 1px #eee;
    // margin-right:10px;
    padding: 10px;
    min-width: 150px;
    width: 150px;
  }
}
.thought.in-list {
  padding: 10px;
  border-top: solid 1px #eee;
}
.author-items {
  padding: 5px;
}
</style>
